import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Layout from "../components/Layout";
import API, { getloginUserId, userId } from "../api/axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { toast } from 'react-toastify';
import { Modal, Button } from "react-bootstrap";
import ProjectDetailsModal from "../components/ProjectDetailsModal";
import Loader from "../components/Loader";

const CategoryDetails = () => {
  const { slug } = useParams();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [projectDetails, setProjectsDetails] = useState();
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const fetchCategoryProjects = async () => {
    try {
      const res = await API.get(`/projects/category/${slug}`);
      setProjects(res.data.data);
    } catch (err) {
      console.error("Failed to fetch category projects", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategoryProjects();
  }, [slug]);

  const viewprojectDetails = async (projectID) => {
      if (typeof projectID === 'string' && projectID.startsWith('dummy-')) {
        toast.info("Project details are not available for sample data.");
        return;
      }
  
      try {
        const res = await API.get(`/projects-details/${projectID}`);
        if (res.data && res.data.success) {
          setProjectsDetails(res.data.data);
          setShowModal(true);
        }
      } catch (err) {
        console.error("Category fetch failed:", err);
        toast.error("Failed to load project details.");
      }
    };

  const handleVote = async (projectId) => {
    if (typeof projectId === "string" && projectId.startsWith("dummy-")) {
      toast.error("This is sample data. Voting is not available.");
      return;
    }

    try {
      const res = await API.post("/votes", {
        user_id: getloginUserId(),
        project_id: projectId,
      });

      const totalVotes = res.data?.data?.total_votes ?? 0;

      setProjects((prev) =>
        prev.map((p) =>
          p.id === projectId ? { ...p, votes_count: totalVotes } : p
        )
      );
    } catch (err) {
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      }
      console.error("Error submitting vote:", err);
    }
  };
    
  return (
    <Layout>
      <div className="mt-4">
        <h1 className="text-xl font-bold capitalize mb-4">
          Projects in <span style={{color:'#ff6600'}}>({slug.replace(/-/g, " ")})</span>
        </h1>

        {loading ? (
          <Loader></Loader>
        ) : projects.length === 0 ? (
          <p>No projects found in this category.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {projects.map((project, index) => (
              <div
                className="col-md-12 col-lg-12 mb-4"
                key={project.id}
                data-index={project.id}
                data-item-index={index}
              >
                <div className="row align-items-center border p-2 rounded">
                  <div className="col-md-2">
                    {project.logo_url && (
                      <img
                        src={project.logo_url}
                        className="rounded"
                        alt={project.name}
                      />
                    )}
                  </div>

                  <div className="col-md-8">
                   <h6
                    className="mb-1 text-muted fw-semibold small"
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => viewprojectDetails(project.id)}
                  >
                       {project.name.charAt(0).toUpperCase() + project.name.slice(1)}
                    </h6>
                    <div className="fw-normal mb-1 small">
                      {project.tagline}
                    </div>
                    <div className="d-flex align-items-center text-muted small">
                      <span className="me-3 project-category-list">
                        <FontAwesomeIcon icon={faTag} />{" "}
                        {project.categories.map((cat) => cat.name).join(", ")}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="upvote-icon-wrapper">
                        <button
                          className="btn btn-white upvote-btn d-flex flex-column align-items-center"
                          type="button"
                          onClick={() => {
                            if (!getloginUserId()) {        
                              navigate('/login');
                            } else {
                              handleVote(project.id);
                            }
                          }}
                        >
                        <div className="upvote-icons">
                          <FontAwesomeIcon icon={faArrowUp} />
                        </div>
                        <div className="upvote-counts">
                          <span>{project.votes_count}</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <ProjectDetailsModal
        showModal={showModal}
        setShowModal={setShowModal}
        projectDetails={projectDetails}
      />
      
    </Layout>
  );
};

export default CategoryDetails;
